import React, { useState,useEffect } from "react";
import CtaLayout from "../components/CtaLayout";
import "../styles/common.css";
import "../styles/cta.css";


function CtaBranding() {

  return (
    <>
      <CtaLayout title="お問い合わせ" lead="CONTACT">
      <div className='cta-box__text'>
        <h3>ロゴデザインの作成、販売戦略の立案からご相談ください。</h3>
        <p>競合他社に勝つためのブランディング支援サービスや、Web集客を軌道に乗せるWebマーケティング代行サービスで得たノウハウを武器に、コンサルティング型のサポートが可能です。<br/>まずはお気軽にお客様の商品やサービスについてお聞かせください。</p>
      </div>
    </CtaLayout>
    </>
  );
}

export default CtaBranding;
